<template>
    <div>
        <div class="overflow-hidden">
            <div class="container d-flex align-items-stretch ui-mh-100vh p-0">
                <div class="row w-100">
                    <div class="d-flex col-md justify-content-center align-items-center order-2 order-md-1 position-relative p-5">
                        <div class="error-bg-skew bg-white"></div>

                        <div class="text-md-left text-center">
                            <h1 class="display-2 font-weight-bolder mb-4">Oops...</h1>
                            <div class="text-xlarge font-weight-light mb-5">Nâo foi possível encontrar a página<br> que você tentou acessar :(</div>
                            <button type="button" class="btn btn-primary" @click="Voltar">←&nbsp; Voltar</button>
                        </div>
                    </div>

                    <div class="d-flex col-md-5 justify-content-center align-items-center order-1 order-md-2 text-center text-white p-5">
                        <div>
                            <div class="error-code font-weight-bolder mb-2">404</div>
                            <div class="error-description font-weight-light">Página não encontrada</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    body{
        background-color: #C3503B !important;
    }
    .error-device-code {
        font-size: 80px;
    }
    @media (min-width: 992px) {
        .error-device-code {
            font-size: 120px;
        }
    }

    .error-device-content {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: -ms-flexbox;
        display: flex;
        align-items: center;
        -ms-flex-align: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        line-height: 1;
    }

    .error-code,
    .error-description {
        line-height: 1;
    }
    .error-code {
        font-size: 100px;
    }
    .error-description {
        font-size: 28px;
    }
    .error-bg-skew {
        position: absolute;
        top: 0;
        right: -50vw;
        bottom: 0;
        z-index: -1;
        width: 200vw;
    }

    @media (min-width: 768px) {
        .error-bg-skew {
            right: 0;
            width: 100vw;
            -webkit-transform: skew(-10deg);
                    transform: skew(-10deg);
        }
    }
</style>

<script>
    export default {
        name: 'basic-404',
        metaInfo: {
            title: '404'
        },

        data: () => ({
        }),

        computed: { 
        },

        methods: {
            Voltar () {
                this.$router.back()
            }
        },

        created: function () {
        },

        mounted () {
           document.body.classList.add('bg-primary')
        },

        destroyed () {
            document.body.classList.remove('bg-primary')
        }
    }
</script>
